import { Backdrop, CircularProgress } from '@mui/material'
import React from 'react'

interface LoadingBackDropProps {
  isloading: boolean
}

const LoadingBackDrop: React.FC<LoadingBackDropProps> = ({ isloading }) => {
  return (
    <Backdrop open={isloading} style={{ zIndex: 9999, color: '#fff', backgroundColor: '#fff' }}>
      <CircularProgress color='primary' size={32} />
    </Backdrop>
  )
}

export default LoadingBackDrop
